// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Highlights -- once shown than dissapeared
document.addEventListener("DOMContentLoaded", () => {
    const url = new URL(window.location.href);

    if (url.searchParams.has("highlight_id")) {
        url.searchParams.delete("highlight_id");
        window.history.replaceState({}, document.title, url.toString());
    }
});
